import { CatalogMediaPhoto } from './CatalogMediaPhoto';
import { CatalogImageUploadButton } from './CatalogImageUploadButton';
import { useCatalogCategoryMedia } from './useCatalogCategoryMedia';

export function CatalogCategoryImage({ categoryId, name }: { categoryId: number; name: string }) {
  const media = useCatalogCategoryMedia(categoryId);
  const { photo, query, isBusy, error } = media;

  return (
    <section className="catalog-editor-section catalog-category-media" aria-label="Картинка категории для витрины">
      <h2>Картинка для витрины</h2>
      <p>Для прозрачного фона загрузите PNG или WebP с прозрачностью. Картинка появится на сайте и в личном кабинете после обработки.</p>
      {photo ? <CatalogMediaPhoto photo={photo} name={name} /> : <p>Картинка ещё не добавлена.</p>}
      <CatalogImageUploadButton label={photo ? 'Заменить картинку' : 'Загрузить картинку'} disabled={isBusy || query.isPending || !!query.error} onSelect={media.select} />
      {photo ? <button className="catalog-button" type="button" disabled={isBusy} onClick={media.remove}>Убрать картинку</button> : null}
      {error || query.error ? <p role="alert">{error || query.error?.message}</p> : null}
      {media.canRetry && error ? <button className="catalog-button" type="button" disabled={isBusy} onClick={media.retry}>Повторить загрузку</button> : null}
      {query.error ? <button className="catalog-button" type="button" onClick={() => { void query.refetch(); }}>Повторить</button> : null}
    </section>
  );
}
